export default __webpack_public_path__ + "static/media/Ballroll_00044.dfcb5143.png";